export default "__VITE_ASSET__BLyk$obF__"